import * as actions from './actions'

const catalogGendersModule = {
    namespaced: true,
    actions,
}

export default catalogGendersModule
